// src/components/Contact.js
import React, { useState } from 'react';
import '../styles/Contact.css';

const Contact = () => {
  const [contactData, setContactData] = useState({ name: '', email: '', message: '' });
  
  const handleChange = (e) => setContactData({ ...contactData, [e.target.name]: e.target.value });
  const handleSubmit = (e) => {
    e.preventDefault();
    console.log('Contact Data:', contactData);
  };

  return (
    <div className="contact-page">
      <div className="profile-section">
        <img src="/images/profile.jpg" alt="Profile" className="profile-img" />
        <div className="profile-info">
          <h2>Pruthviraj patil</h2>
          <p>Email: pruthviraj.pp5@gmail.com</p>
          <p>Contact: +91 6360236070</p>
        </div>
      </div>
      <div className="form-container">
        <h2>Contact Us</h2>
        <form onSubmit={handleSubmit} className="contact-form">
          <label>
            Name:
            <input 
              type="text" 
              name="name" 
              value={contactData.name} 
              onChange={handleChange} 
              required 
            />
          </label>
          <label>
            Email:
            <input 
              type="email" 
              name="email" 
              value={contactData.email} 
              onChange={handleChange} 
              required 
            />
          </label>
          <label>
            Message:
            <textarea 
              name="message" 
              value={contactData.message} 
              onChange={handleChange} 
              required
            ></textarea>
          </label>
          <button type="submit" className="btn">Send Message</button>
        </form>
      </div>
    </div>
  );
};

export default Contact;
